import { mapActions, mapGetters } from 'vuex';
import Cookies from 'js-cookie';
import { cookieMapper } from '@/assets/js/cookie-mapper';
import legalDocuments from '@/mixins/legalDocuments';
import { Capacitor } from '@capacitor/core';

export default {
  mixins: [legalDocuments],
  data() {
    return {
      documentContent: {
        content: ''
      }
    };
  },
  computed: {
    ...mapGetters({
      cookiesSettings: 'cookiesConsent/cookiesSettings',
      consentList: 'cookiesConsent/consentList',
      isMobileApp: 'general/isMobileApp'
    }),
    showCookiesSettings: {
      get() {
        return this.$store.state.cookiesConsent.showCookiesSettings;
      },
      set(value) {
        this.$store.commit('cookiesConsent/setShowCookiesSettings', value);
      }
    },
    showCookiesDocument: {
      get() {
        return this.$store.state.cookiesConsent.showCookiesDocument;
      },
      set(value) {
        this.$store.commit('cookiesConsent/setShowCookiesDocument', value);
      }
    },
    showCookiesDialog: {
      get() {
        return this.$store.state.cookiesConsent.showCookiesDialog;
      },
      set(value) {
        this.$store.commit('cookiesConsent/setShowCookiesDialog', value);
      }
    },
    cookiesSettings: {
      get() {
        return this.$store.state.cookiesConsent.cookiesSettings;
      },
      set(value) {
        this.$store.commit('cookiesConsent/setCookiesSettings', value);
      }
    }
  },
  methods: {
    ...mapActions({
      setCookiesSettings: 'cookiesConsent/setCookiesSettings',
      setShowCookiesSettings: 'cookiesConsent/setShowCookiesSettings',
      setShowCookiesDialog: 'cookiesConsent/setShowCookiesDialog'
    }),

    async initCookies(forceHide) {
      this.documentContent = await this.getLegalDocument('default', 'cookies');
      let cookies = {};

      for (const item of this.consentList) {
        const itemCookie = Cookies.get(`cookie-preference_${item.identifier}`);
        if (!itemCookie) {
          cookies[item.identifier] = null;
        } else {
          cookies[item.identifier] = itemCookie === 'yes';
        }
      }

      const cookiesConsentGranted = new Date(parseInt(Cookies.get('cookies-consent-granted')));
      const cookiesSet = this.consentList.every(item => {
        return Cookies.get(`cookie-preference_${item.identifier}`);
      });

      const cookieConsentValid = !isNaN(cookiesConsentGranted.valueOf()) && cookiesSet;
      if (!cookieConsentValid && !forceHide) {
        this.gtmPush({
          event: 'notification_show',
          'notification.type': 'cookie_panel'
        });
        this.setShowCookiesDialog(true);
      }

      cookies.technical = true;
      this.setCookiesSettings(cookies);
    },
    acceptCookies() {
      for (let cookieKey of Object.keys(this.cookiesSettings)) {
        if (this.cookiesSettings[cookieKey] === true) {
          this.gtmPush({ event: 'consentgranted', consent_type: cookieKey });
        } else {
          cookieMapper[cookieKey].forEach(ctd => Cookies.remove(ctd));
        }

        this.gtmPush({
          event: 'consent_update',
          'consent.cookie': cookieKey,
          'consent.value': this.cookiesSettings[cookieKey] === true ? 'yes' : 'no'
        });

        Cookies.set(
          `cookie-preference_${cookieKey}`,
          this.cookiesSettings[cookieKey] === true ? 'yes' : 'no',
          { expires: 365 }
        );
      }

      Cookies.set('cookies-consent-granted', new Date().valueOf(), { expires: 365 });

      this.gtmPush({
        event: 'notification_close',
        'notification.type': 'cookie_panel'
      });

      this.setShowCookiesDialog(false);
      this.setShowCookiesSettings(false);
    },
    acceptFunctionalCookies() {
      this.updateCookieSettings({ type: 'functional', value: true });
      this.acceptCookies();
    },
    switchAllCookies(result) {
      const newSettings = {};
      Object.keys(this.cookiesSettings).forEach(
        key => (newSettings[key] = key === 'technical' || result)
      );
      this.setCookiesSettings(newSettings);
      this.acceptCookies();
    },
    updateCookieSettings(payload) {
      const newSettings = { ...this.cookiesSettings };
      newSettings[payload.type] = payload.value;
      this.setCookiesSettings(newSettings);
    },
    acceptAllCookies() {
      this.switchAllCookies(true);
    },
    denyAllCookies() {
      this.switchAllCookies(false);
    }
  },
  mounted() {
    this.initCookies(this.isMobileApp && !Capacitor.isNativePlatform());
  }
};
